import _get from "lodash/get";
import { css } from 'styled-components';
import { rem } from 'polished';
import { baseTheme } from '~base-theme';
import horizontalScrollTheme from './horizontalScrollTheme';

var horizontalScrollbarStyles = function horizontalScrollbarStyles() {
  return css(["&::-webkit-scrollbar{height:", ";}&::-webkit-scrollbar-track{border-radius:", ";}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:", ";}"], function (_ref) {
    var theme = _ref.theme;
    return rem(_get(theme, 'horizontalScroll.scrollbar.height', horizontalScrollTheme.horizontalScroll.scrollbar.height));
  }, function (_ref2) {
    var theme = _ref2.theme;
    return rem(_get(theme, 'base.borderRadius.default', baseTheme.base.borderRadius.default));
  }, function (_ref3) {
    var theme = _ref3.theme;
    return _get(theme, 'base.grays.grayLighter', baseTheme.base.grays.grayLighter);
  }, function (_ref4) {
    var theme = _ref4.theme;
    return rem(_get(theme, 'base.borderRadius.default', baseTheme.base.borderRadius.default));
  });
};

export default horizontalScrollbarStyles;